import Image from 'next/image';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

export const HappyUsers = ({
  className,
  fromLandingPage,
}: {
  className?: string;
  fromLandingPage?: boolean;
}) => {
  const { t } = useLocale('home');

  return (
    <div
      className={clsxm('mt-5 flex space-x-4 rtl:space-x-reverse', className)}
    >
      <div className='flex -space-x-3 overflow-hidden rtl:space-x-reverse'>
        <Image
          src='/images/ankita.png'
          alt=''
          width='32'
          height='32'
          className='v-lazy-image v-lazy-image-loaded inline-block aspect-[1/1] h-8 w-8 rounded-full border-[2px] border-indigo-400'
        />
        <Image
          src='/images/dmytro.jpg'
          alt=''
          width='32'
          height='32'
          className='v-lazy-image v-lazy-image-loaded inline-block aspect-[1/1] h-8 w-8 rounded-full border-[2px] border-indigo-400'
        />
        <Image
          src='/images/marianna_ole.jpeg'
          alt=''
          width='32'
          height='32'
          className='v-lazy-image v-lazy-image-loaded inline-block aspect-[1/1] h-8 w-8 rounded-full border-[2px] border-indigo-400'
        />
        <Image
          src='/images/andrea.webp'
          alt=''
          width='32'
          height='32'
          className='v-lazy-image v-lazy-image-loaded inline-block aspect-[1/1] h-8 w-8 rounded-full border-[2px] border-indigo-400'
        />
        <Image
          src='/images/cody.jpeg'
          alt=''
          width='32'
          height='32'
          className='v-lazy-image v-lazy-image-loaded inline-block aspect-[1/1] h-8 w-8 rounded-full border-[2px] border-indigo-400'
        />
      </div>{' '}
      <p
        className={clsxm(
          'mx-auto max-w-lg text-sm  text-gray-500 lg:mx-0',
          fromLandingPage ? 'text-slate-200' : 'text-gray-500',
        )}
      >
        <strong>3,482,705+</strong> {t('happy users')}
      </p>{' '}
      <div className='convert-13-v1 flex'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'
          className='h-4 w-4 text-yellow-400'
        >
          <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
        </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'
          className='h-4 w-4 text-yellow-400'
        >
          <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
        </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'
          className='h-4 w-4 text-yellow-400'
        >
          <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
        </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'
          className='h-4 w-4 text-yellow-400'
        >
          <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
        </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='currentColor'
          className='h-4 w-4 text-yellow-400'
        >
          <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
        </svg>
      </div>
    </div>
  );
};

export default HappyUsers;
